function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ced6e0;}.b{fill:#fff;fill-rule:evenodd;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1132 -44)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M16.557,0A16.557,16.557,0,1,1,0,16.557,16.557,16.557,0,0,1,16.557,0Z",
  transform: "translate(1132 44)"
}), /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M20.955,10.729a9.768,9.768,0,0,0-1.651-.18c-1.187,0-1.264.516-1.264,1.342v1.47h2.967L20.748,16.4H18.04v9.26H14.326V16.4H12.417V13.36h1.909V11.477c0-2.579,1.212-4.024,4.256-4.024a12.947,12.947,0,0,1,2.837.361Z",
  transform: "translate(1132 44)"
}));

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.114,
    height: 33.114,
    viewBox: "0 0 33.114 33.114",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.f1488798.svg";
export { ForwardRef as ReactComponent };